import { takeLatest, put, select } from 'redux-saga/effects'
import moment from 'moment'
import { Types } from '../ducks/wallet'
import powerAppsApi from '../../services/powerapps/index'
import { notifyError, notifySuccess } from '../../utils/notify'

function* getWalletResume() {
  try {
    const userEmail = yield select(state => state.auth.user.mail)

    const res = yield powerAppsApi.post('/', {
      acao: 'listar_resumo_conta_colaborador',
      user_email: userEmail,
      orcRubr_id: 0,
    }, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.tron.log('getWalletResume', res.data)

    yield put({
      type: Types.GET_WALLET_RESUME_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log('erro', err)
    notifyError('Erro ao buscar resumo da carteira.')
    yield put({
      type: Types.GET_WALLET_RESUME_FAILED,
      payload: JSON.stringify(err),
    })
  }
}

function* getFullStatement() {
  try {
    const userEmail = yield select(state => state.auth.user.mail)

    const res = yield powerAppsApi.post('/', {
      acao: 'listar_itens_conta_colaborador',
      user_email: userEmail,
    }, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.tron.log('getFullStatement', res.data)

    yield put({
      type: Types.GET_FULL_STATEMENT_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log('erro', err)
    notifyError('Erro ao buscar extrato da carteira.')
    yield put({
      type: Types.GET_FULL_STATEMENT_FAILED,
      payload: JSON.stringify(err),
    })
  }
}

function* getRubrics() {
  try {
    const userEmail = yield select(state => state.auth.user.mail)

    const res = yield powerAppsApi.post('/', {
      acao: 'listar_projetos_tecnico',
      user_email: userEmail,
    }, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    const data = res.data.map(rubric => ({
      value: rubric.orcRubr_id,
      label: rubric.orcRubr_nome,
    }))

    console.tron.log('getRubrics', data)

    yield put({
      type: Types.GET_RUBRICS_SUCCEEDED,
      payload: data,
    })
  } catch (err) {
    console.tron.log('erro', err)
    notifyError('Erro ao buscar rubricas.')
    yield put({
      type: Types.GET_RUBRICS_FAILED,
      payload: JSON.stringify(err),
    })
  }
}

function* getSubRubrics(action) {
  try {
    const rubric = action.payload

    const res = yield powerAppsApi.post('/', {
      acao: 'listar_subrubricas',
      orcRubr_id: rubric,
    }, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    const data = res.data.map(subRubric => ({
      value: subRubric.orcRubr_id,
      label: subRubric.orcRubr_nome,
    }))

    console.tron.log('getRubrics', data)

    yield put({
      type: Types.GET_SUBRUBRICS_SUCCEEDED,
      payload: data,
    })
  } catch (err) {
    console.tron.log('erro', err)
    notifyError('Erro ao buscar subrubricas.')
    yield put({
      type: Types.GET_SUBRUBRICS_FAILED,
      payload: JSON.stringify(err),
    })
  }
}

function* addExpense(action) {
  try {
    const userEmail = yield select(state => state.auth.user.mail)
    const { id, subRubric, date, value, description, files } = action.payload

    const formData = new FormData()
    formData.append('acao', 'incluir_itens_conta_colaborador')
    formData.append('user_email', userEmail)
    formData.append('orcRubr_id', subRubric.value)
    formData.append('mov_desc', description)
    formData.append('mov_dtQuit', moment(date).format('DD/MM/YYYY'))
    formData.append('mov_vlr', value.toString().replace('.', ','))
    formData.append('conta_id', id)

    if (files && files.length > 0) {
      files.forEach((file, index) => {
        formData.append(`arquivo${index}`, new Blob([file], { type: file.type }), file.name || 'file')
      })
    }

    console.tron.log('addExpense formData', formData)

    const res = yield powerAppsApi.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    console.tron.log('addExpense', res.data)

    notifySuccess('Despesa adicionada com sucesso.')

    yield put({ type: Types.ADD_EXPENSE_SUCCEEDED })
  } catch (err) {
    console.tron.log('erro', err)
    notifyError('Erro ao adicionar despesa.')
    yield put({
      type: Types.ADD_EXPENSE_FAILED,
      payload: JSON.stringify(err),
    })
  }
}

export const walletSagas = [
  takeLatest(Types.GET_WALLET_RESUME_REQUESTED, getWalletResume),
  takeLatest(Types.GET_FULL_STATEMENT_REQUESTED, getFullStatement),
  takeLatest(Types.GET_RUBRICS_REQUESTED, getRubrics),
  takeLatest(Types.GET_SUBRUBRICS_REQUESTED, getSubRubrics),
  takeLatest(Types.ADD_EXPENSE_REQUESTED, addExpense),
]
